import React from 'react';
import { Settings, FileCheck } from 'lucide-react';
import { ModuleFilter } from '../types';
import './ModuleFilter.css';

interface ModuleFilterProps {
  selectedModule: ModuleFilter;
  onModuleChange: (module: ModuleFilter) => void;
  causacionCount: number;
  acuseCount: number;
  totalCount: number;
}

// Mapeo de módulos
export const MODULE_NAMES = {
  'use_accounting_system': 'Causación',
  'acuse_recibo_module': 'Acuse'
};

export const getModuleDisplayName = (moduleKey: string): string => {
  return MODULE_NAMES[moduleKey as keyof typeof MODULE_NAMES] || moduleKey;
};

export const getModuleIcon = (moduleKey: string) => {
  switch (moduleKey) {
    case 'use_accounting_system':
      return <Settings size={14} />;
    case 'acuse_recibo_module':
      return <FileCheck size={14} />;
    default:
      return <Settings size={14} />;
  }
};

const ModuleFilterComponent: React.FC<ModuleFilterProps> = ({
  selectedModule,
  onModuleChange,
  causacionCount,
  acuseCount,
  totalCount
}) => {
  const moduleOptions = [
    { 
      value: 'all' as ModuleFilter, 
      label: 'Todos los Módulos', 
      count: totalCount,
      className: 'all',
      icon: <Settings size={16} />
    },
    { 
      value: 'use_accounting_system' as ModuleFilter, 
      label: 'Causación', 
      count: causacionCount,
      className: 'causacion',
      icon: <Settings size={16} />
    },
    { 
      value: 'acuse_recibo_module' as ModuleFilter, 
      label: 'Acuse', 
      count: acuseCount,
      className: 'acuse',
      icon: <FileCheck size={16} />
    }
  ];

  return (
    <div className="module-filter">
      <div className="module-filter-header">
        <Settings size={18} />
        <span>Filtrar por Módulos:</span>
      </div>
      <div className="module-filter-options">
        {moduleOptions.map((option) => (
          <button
            key={option.value}
            className={`module-filter-button ${option.className} ${
              selectedModule === option.value ? 'active' : ''
            }`}
            onClick={() => onModuleChange(option.value)}
          >
            {option.icon}
            <span className="module-label">{option.label}</span>
            <span className="module-count">({option.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModuleFilterComponent;
